import { cn } from '@ui/lib/utils'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-m bg-gray-100', className)}
      {...props}
    />
  )
}

export { Skeleton }
